<template>
    <div>
        <el-drawer ref="qiyeDraw" title="结算" :visible.sync="isShow" size="900px" @close="handleClose">
            <div class="company_info">
                <div class="name"><span>{{tableDetail.name}}</span><el-button type="primary" size="mini" :disabled="(tableDetail.noSettlePayment <= 0 || activeName != '1')" @click="handleConClude">结算</el-button></div>
                <div class="account">
                    <b>待结算金额: <span>¥{{tableDetail.noSettlePayment || 0}}</span></b>
                    <b>已结算金额: <span>¥{{tableDetail.settlePayment || 0}}</span></b>
                    <b>结算中: <span>¥{{tableDetail.inSettlePayment || 0}}</span></b>
                </div>
            </div>
            <el-tabs v-model="activeName" @tab-click="handleClickOrigin">
                <el-tab-pane label="待结算明细" name="1"></el-tab-pane>
                <el-tab-pane label="结算记录" name="2"></el-tab-pane>
            </el-tabs>
            <el-form v-if="activeName == '1'" :inline="true" :model="searchForm" size="small" ref="searchForm" @keyup.enter.native="handleSearch" label-width="90px">
                <el-form-item label="订单号" prop="orderNo">
                    <el-input v-model="searchForm.orderNo" placeholder="请输入订单号" style="width: 230px"></el-input>
                </el-form-item>
                <el-form-item label="入住人" prop="customerName">
                    <el-input v-model="searchForm.customerName" placeholder="请输入入住人" style="width: 230px"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-select v-model="searchForm.status" placeholder="请选择" style="width: 120px">
                        <el-option label="已入住" :value="4"></el-option>
                        <el-option label="已退房" :value="6"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleSearch" size="small">查询</el-button>
                    <el-button @click="handleReset" size="small">重置</el-button>
                </el-form-item>
            </el-form>
            <el-table v-if="activeName == '1'" border size="small" style="width: 100%; margin-top: 10px" :data="tableData" v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                <el-table-column type="index" label="#" align="center"></el-table-column>
                <el-table-column prop="createTime" label="支付时间" width="150"></el-table-column>
                <el-table-column prop="orderNo" label="订单号" width="180"></el-table-column>
                <el-table-column prop="customerName" label="入住人" width="120"></el-table-column>
                <el-table-column prop="customerMobile" label="手机号" width="120"></el-table-column>
                <el-table-column prop="openStatus" label="入住详情" width="180" show-overflow-tooltip>
                    <template slot-scope="{ row }">
                        <span>{{`入住时间:`}}{{row.estimatedCheckIn}}{{`共${row.days || 0}晚`}}{{row.estimatedCheckOut}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="enterContact" label="申请人" width="120"></el-table-column>
                <el-table-column prop="lastPay" label="支付总金额" width="120"></el-table-column>
                <el-table-column prop="settleStatus" label="结算状态" width="120">
                    <template slot-scope="{ row }">
                        <el-tag type="danger" size="mini" v-if="row.settleStatus == 0">未结算</el-tag>
                        <el-tag type="success" size="mini" v-if="row.settleStatus == 1">已结算</el-tag>
                        <el-tag type="info" size="mini" v-if="row.settleStatus == 2">结算中</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="statusDesc" label="状态" width="130">
                    <template slot-scope="{ row }">
                        <el-tag type="danger" v-if="row.status == 6">{{ row.statusDesc }}</el-tag>
                        <el-tag v-else>{{ row.statusDesc }}</el-tag>
                    </template>
                </el-table-column>
            </el-table>
            <el-table v-if="activeName == '2'" border size="small" style="width: 100%; margin-top: 10px" :data="tableData" v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                <el-table-column type="index" label="#" align="center"></el-table-column>
                <el-table-column prop="createTime" label="结算时间" width="150"></el-table-column>
                <el-table-column prop="name" label="结算公司" width="120"></el-table-column>
                <el-table-column prop="paymentTime" label="支付时间" width="120"></el-table-column>
                <el-table-column prop="settlePayment" label="结算金额" width="120"></el-table-column>
                <el-table-column prop="settleStatus" label="状态" width="120">
                    <template slot-scope="{ row }">
                        <el-tag type="danger" size="mini" v-if="row.settleStatus == 0">结算中</el-tag>
                        <el-tag type="success" size="mini" v-if="row.settleStatus == 1">已结算</el-tag>
                        <el-tag type="info" size="mini" v-if="row.settleStatus == 2">已取消</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="settleType" label="结算方式" width="120">
                    <template slot-scope="{ row }">
                        <el-tag type="info" size="mini" v-if="row.settleType == 0">微信支付</el-tag>
                        <el-tag type="success" size="mini" v-if="row.settleType == 1">线下结算</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="proofImage" label="结算凭证" width="120">
                    <template slot-scope="{ row }">
                        <el-image v-if="row.proofImage" style="width: 100px; height: 100px" :src="row.proofImage" fit="cover" :preview-src-list="[row.proofImage]" alt="空"></el-image>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" align="center" width="120">
                    <template slot-scope="{ row }">
                        <el-button size="mini" type="text" v-if="row.settleStatus == 0" @click="handleShare(row.id)">转发</el-button>
                        <el-button size="mini" type="text" v-if="row.settleStatus == 0 && flag" @click="handleCancel(row.id)">取消</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleChangeSize" @current-change="handleChangePage" style="text-align:right;margin-top:10px;" :current-page="searchForm.pageNumber" :page-sizes="[10, 20, 50]" :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="total"></el-pagination>
        </el-drawer>
        <el-dialog :visible.sync="isView" title="结算分享码" width="400px" append-to-body destroy-on-close :close-on-press-escape="false" :close-on-click-modal="false">
            <div class="flex">
                <img :src="imgUrl" alt="" style="max-height: 150px;max-width: 150px;border-radius: 50%;" />
            </div>
            <div slot="footer">
                <el-button size="small" type="primary" @click="isView = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>


<script>
import { deepClone } from '@/utils/util'
export default {
    props: {
        isShowDetail: {
            type: Boolean,
            default: false,
        },
        hotelId: {
            type: String,
            default: null,
        },
        enterpriseId: {
            type: String,
            default: ''
        }
    },
    computed: {
        headers() {
            return {
                Authorization: localStorage.getItem("Token"),
            };
        },
    },
    data() {
        return {
            isView: false,
            flag: true,
            isShow: false,
            searchForm: {
                orderNo: "",
                customerName: '',
                status: 4,
                hotelId: this.hotelId,
                pageNumber: 1,
                pageSize: 10,
            },
            tableDetail: {},
            activeName: '1',
            isLoading: false,
            tableData: [],
            total: 0,
            selectTime: [],
            isAdd: false,
            modelForm: {

            },
            imgUrl: "",
            submitLoading: false,
        };
    },
    mounted() {
        this.activeName = '1'
        this.searchForm = {
            orderNo: "",
            status: 4,
            customerName: '',
            hotelId: this.hotelId,
            pageNumber: 1,
            pageSize: 10,
        }
    },
    watch: {
        isShowDetail(newVal) {
            this.isShow = !!newVal;
            if (!!newVal) {
                this.searchForm = {
                    orderNo: "",
                    customerName: '',
                    status: 4,
                    enterpriseId: this.enterpriseId,
                    pageNumber: 1,
                    pageSize: 10,
                };
                this.getTableDetail();
                if (this.activeName == '1') {
                    this.$nextTick(() => {
                        this.getTableData();
                    })
                } else {
                    this.$nextTick(() => {
                        this.getTableList();
                    })
                }
            }
        },
    },
    methods: {
        handleClose() {
            this.isShow = false;
            this.$emit('update:isShowDetail', this.isShow)
        },
        handleClickOrigin(val) {
            if (val.name == '1') {
                this.getTableData();
            } else {
                this.getTableList();
            }
        },
        handleSearch() {
            this.searchForm.pageNumber = 1;
            this.getTableData();
        },

        handleReset() {
            this.searchForm = {
                orderNo: "",
                status: 4,
                customerName: '',
                pageSize: 10,
                pageNumber: 1,
            };
            this.getTableData();
        },

        handleChangePage(page) {
            this.searchForm.pageNumber = page;
            if (this.activeName == '1') {
                this.getTableData();
            } else {
                this.getTableList();
            }
        },

        handleChangeSize(size) {
            this.searchForm.pageNumber = 1;
            this.searchForm.pageSize = size;
            if (this.activeName == '1') {
                this.getTableData();
            } else {
                this.getTableList();
            }
        },
        handleConClude() {
            this.$confirm(`您是否需要将待结算资金${this.tableDetail.noSettlePayment}全部结算并生成账单`, {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.postRequest(`/df-front/order/addEnterSettleOrder`, { enterpriseId: this.enterpriseId, hotelId: this.hotelId, settlePayment: this.tableDetail.noSettlePayment, name: this.tableDetail.name }).then((res) => {
                    let data = res.data;
                    if (data.code == 200) {
                        this.$message.success("生成结算记录成功");
                        this.getTableData();
                        this.getTableDetail();
                    }
                });
            });
        },
        handleCancel(id) {
            this.$confirm(`您是否确认取消结算？`, {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.formDataPost(`/enterSettleRecord/cancel`, { id }).then((res) => {
                    let data = res.data;
                    if (data.code == 200) {
                        this.$message.success("取消成功");
                        this.getTableDetail();
                        this.getTableList();
                    }
                });
            });
        },
        handleShare(settleId) {
            this.exportRequest(`/enterSettleRecord/getMiniProgramCode?settleId=${settleId}&path=/pages/companyManage/companyUser/shareDetail/index`)
                .then(res => {
                    this.flag = false
                    let reader = new FileReader();
                    reader.readAsText(res.data, "utf-8")
                    reader.onload = e => {
                        let data = e.target.result;
                        if (!data.includes("msg")) {
                            let blob = new Blob([res.data], { type: 'image/png' });

                            let reader = new FileReader();
                            reader.readAsDataURL(blob);

                            reader.onload = e => {
                                this.imgUrl = e.target.result;
                                this.isView = true
                            }
                        } else {
                            // this.$message.warning(JSON.parse(data).msg);
                        }

                    }
                })
        },
        getTableList() {
            this.isLoading = true;
            this.searchForm.enterpriseId = this.enterpriseId
            this.getRequest("/enterSettleRecord/getPage", this.searchForm).then((res) => {
                let data = res.data;
                this.isLoading = false;
                if (data.code == 200) {
                    this.tableData = data.data.records;
                    this.total = data.data.total;
                }
            });
        },
        getTableDetail() {
            this.getRequest("/enterprise/getDetail", { id: this.enterpriseId }).then((res) => {
                let data = res.data;
                this.isLoading = false;
                if (data.code == 200) {
                    this.tableDetail = data.data;
                }
            });
        },
        getTableData() {
            this.isLoading = true;
            this.searchForm.enterpriseId = this.enterpriseId;
            this.getRequest("/api/roomOrder/page2", this.searchForm)
                .then(res => {
                    this.isLoading = false;
                    let data = res.data;
                    if (data.code == 200) {
                        this.tableData = data.data.records;
                        this.total = data.data.total;
                    }
                }).catch(() => {
                    this.isLoading = false;
                })
        },

    },
};
</script>

<style lang="less">
.company_info {
    padding: 0px 16px;
    .name {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        > span {
            font-size: 24px;
        }
    }
    .account {
        height: 40px;
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 14px;
        > b {
            font-weight: normal;
            margin-right: 50px;
            > span {
                color: #61acff;
            }
        }
    }
}
.flex {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>